import { createApi } from "@reduxjs/toolkit/query/react";
import {createCustomFetchBaseQuery} from "../baseQuery";


export const ShopAdminDasbhoardApi=createApi({
    reducerPath:"shop-admin-dashboard",
    baseQuery:createCustomFetchBaseQuery(),
    endpoints:(builder)=>({
        getShopAdminDashboard:builder.query({
            query:()=>({
                url:`/shop-admin/dashboard`,
                method:"GET",
            }),
            providesTags:["ShopAdmin"],
        })
    })
});

export const {useGetShopAdminDashboardQuery}=ShopAdminDasbhoardApi;